import { useQuery } from '@tanstack/react-query';
import { osrmService } from '../services/osrm.service';

// AIDEV-NOTE: Hook para otimizacao de rota via OSRM Trip API
// AIDEV-PERF: staleTime de 15min — evita chamadas desnecessarias ao OSRM publico

export function useOSRM(coords: Array<{ lat: number; lng: number }> | undefined) {
  return useQuery({
    queryKey: ['osrm-route', coords?.map((c) => `${c.lat},${c.lng}`).join('|')],
    queryFn: async () => {
      if (!coords || coords.length < 2) return null;
      const route = await osrmService.optimizeRoute(coords);
      if (!route) return null;
      return {
        latLngs: osrmService.parseToLatLngs(route),
        distance: osrmService.formatDistance(route.trips[0]?.distance ?? 0),
        duration: osrmService.formatDuration(route.trips[0]?.duration ?? 0)
      };
    },
    enabled: !!coords && coords.length >= 2,
    staleTime: 15 * 60 * 1000
  });
}
